import moment from 'moment';

export const DEFAULT_FROM_TIME_VALUE = '00:00';

export const MIN_DEFAULT_TILL_TIME_VALUE = '00:01';

export const MAX_DEFAULT_TILL_TIME_VALUE = '23:59';

const FOUR_DIGIT_YEAR = /^\d{4}$/;

export const VALIDATION_TEXTS_TIME_INPUTS = {
	endTimeEqualValidationMsg: 'End time should not be equal to start time',
	endTimeGreaterValidationMsg: 'End time should not be set before start time',
};

export const VALIDATION_TEXTS_DATE_INPUTS = {
	invalidYearMsg: 'Please enter a valid year',
	endBeforeStartMsg: 'End date must not precede start date',
};

export function getValidYearRange() {
	const currentYear = moment().year();

	return { min: currentYear - 1, max: currentYear + 1 };
}

export const getOverlappingActivityAction = ({ allowToDeleteOverlaps, allowToDelayOverlaps }) => {
	if (allowToDeleteOverlaps) return 'cancel';
	if (allowToDelayOverlaps) return 'delay';
	return null;
};

export const validateYear = (dateString) => {
	if (!dateString) return true;

	const yearStr = dateString.split('-')[0];

	if (!FOUR_DIGIT_YEAR.test(yearStr)) {
		return VALIDATION_TEXTS_DATE_INPUTS.invalidYearMsg;
	}

	const year = parseInt(yearStr, 10);
	const { min, max } = getValidYearRange();

	if (year < min || year > max) {
		return VALIDATION_TEXTS_DATE_INPUTS.invalidYearMsg;
	}

	return true;
};
